import { Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { FileUploader } from "ng2-file-upload";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ContactService } from './../../services/contact.service';
import { SoaImageService } from './../../services/soa-image.service';
import { CompanyService } from './../../services/company.service';
import { ProfessionalService } from './../../services/professional.service';
import { EncrDecrService } from './../../services/encr-decr.service';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
declare var $: any;
import 'rxjs/add/operator/map'
import { saveAs } from 'file-saver';
import { UserService } from '../../services/user.service';
import { FactoringInvoiceService } from '../../services/factoring-invoice.service';

@Component({
  selector: 'app-edit-mobile',
  templateUrl: './edit-mobile.component.html',
  styleUrls: ['./edit-mobile.component.css']
})
export class EditMobileComponent implements OnInit {
  modalRef: BsModalRef;
  config: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-lg'
  };
  config1: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };
  config2: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
  };
  config3: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };

  /// multiple file upload  code start
  uploadForm: FormGroup;

  public uploader: FileUploader = new FileUploader({
    isHTML5: true
  });
  ////end
  fileName: string;
  filePreview: string

  folderid: any = '';
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  customerList: object = [];

  model: any = { customer: '', reference_number: '', po_number: '', work_week: '', user_per: '', mobile_invoice_number: '' };

  page: number = 1;
  totalPages: number;
  isLoaded: boolean = false;
  isActive: false;

  folderImageList: object = [];
  folderDocList: object = [];

  imageDiv: boolean = true;
  delete_id: number = 0;
  filePath: any = 'assets/images/loader.gif';
  pdfSrc: string = '';

  imagepfdfSrc: string = '';
  maxDate: Date;
  fileModel: any = {};
  canvasmode: boolean = false;
  factmodel: object = {};
  inv_number_new: any;
  factInstructions: any = '';
  factAssigned_notice: any = '';
  factFinance_company: any = '';
  factFact_address1: any = '';
  factFact_city_state: any = '';
  factFact_email: any = '';
  mergeStatus: boolean = false;
  merge_delete_id: any = 0;
  mergeActionStatus: boolean = false;
  loaderMode: boolean = false;
  display: any = 'none';
  customer_id: any = 0;
  emailModel: any = {};
  random: any = 0;
  loaderCount: any = 0;
  currentUserRole: any = '';
  abc: any = [];
  validFolderError: any = false;
  nonfactmode: any = 1;
  privatemode: any = 1;
  isMobFolderInfoChange: any = false;
  fact_status: any;
  isMobFolderInfoInvoiceNotBlank: any = false;
  isMobFolderInfoInvoiceBlank: any = false;
  folder_id_e: any = 0;
  emailModal: any = true;
  emailModalError: any = false;
  folderCustMode: any = false;
  imagesCount: number = 0;
  pdfCount: number = 0;

  userList = [];
  selectedUsers: any = [];
  userDropdownSettings = {};
  check_per_mode: boolean = false;
  user_per: any = '';
  assign_fact_check_css: any = 'block';
  uploadFileUrl: any = [];
  createInvoiceDiv: any = false;

  step1Div: any = true;
  createdivbutton: any = true;
  edit_divbutton: any = false;
  submitted = false;
  submitForm: FormGroup;

  subTotal: number = 0.00;
  discount: number = 0.00;
  shipping: number = 0.00;
  totalDiscount: number = 0.00;
  total: number = 0.00;
  total_tax: number = 0.00;
  selectedRowIndex: any;
  newLineIndex: any;
  showAmount: any;
  newProduct: string;
  qty: any[];
  price: any[];
  tax: any;
  amount: any[];
  items: any[];
  selectedQuantity: any[];
  mobile_invoice_id: any[];
  itemDesc: any[];
  item: string;
  products: any[];
  showSubTotal: any;
  grandtotal: any;
  showTotal: any;
  checkbox_value: any[];
  discount_type: any;
  dis_amt: any;
  taxamount: any;
  showtax: any;
  inv_number: any;
  inv_row: any;
  invoice_item_row: any[];

  mobile_invoice_item_id: any;

  inv_pdf_path: any;
  showInvoicenumDiv: any = false;
  invoice_label_create_div: any = true;
  invoice_label_edit_div: any = false;

  autoload_check: any = 'yes';
  Selected: any = [];
  IsAllChecked: any = true;

  //30march archana
  isInvoicePaymentStatusPaid: any = false;
  inv_payment_status: any = false;
  //30march archana

  defaultZoom: number = 1;
  screenHeight: any = '';
  screenWidth: any = '';
  isDisabled = false;

  //by deepak 13/april/2022
  confidentialFilesCount: number = 0;
  folderConfidentialList: object = [];

  ref_number: any;

  folderid_encrypt: any;

  professionalList: any;

  customer_taxrate: any;
  work_week_val: any;

  isExcelFile: boolean;
  data: any = [];
  displayCsvconfirmation: any = 'none';
  arrayBuffer: any;
  file: any;
  filelist: any[];
  invoice_import: any[] = [];
  importsuccess: any;
  hours_worked_s: any;
  calculated_s: any;

  //this veriable is for scroll after import invoice 
  position: any;
  private lastScrollY = 0; // Declare the lastScrollY property
  private drawLoadNo = 1;
  private start = 0;
  private isLoading: boolean = false;

  importRecordsTotal: any;
  showLoaderMsg: boolean = false;
  importRecordsFiltered: any = 0;

  //variable added by rahat sheikh 14-09-2023
  factInvoiceMode: any = 'add';
  fact_invoice_id: any = 0;
  modelFact: any = { customer_name: '', invoice: '', date_invoice: '', terms: '', amount: '', reference_number: '', po_number: '', work_week: '', load_number: '', mode: 'add', sub_total: '', Tax_amount: '' };
  btnDisableFact: boolean;
  rfolderid: any = 0;
  professionalInactiveList: any = [];
  deletearrayInvoice: any = [];
  //end

  constructor(
    private _router: Router,
    private _contact: ContactService,
    private formbuilder: FormBuilder,
    private _soaImage: SoaImageService,
    private _company: CompanyService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private _user: UserService,
    private http: HttpClient,
    private datePipe: DatePipe,
    private EncrDecr: EncrDecrService,
    private _professional: ProfessionalService,
    private _factInvoice: FactoringInvoiceService
  ) { }

  get dynamicFields() {
    return this.submitForm.controls["dynamicFields"] as FormArray;
  }

  ngOnInit() {
    this.screenHeight = $(window).height();
    this.screenWidth = $(window).width();

    this.inv_row = 0;
    this.maxDate = new Date();
    this.newProduct = '';
    this.qty = [];
    this.qty[0] = 1;
    this.price = [];
    this.tax = [];
    this.amount = [];
    this.showAmount = [];
    this.items = [];
    this.invoice_item_row = [];
    this.selectedQuantity = [];
    this.Selected = [];
    this.IsAllChecked = true;
    this.mobile_invoice_id = [];
    this.inv_number_new = '';
    this.itemDesc = [];
    this.item = '';

    this.products = [];
    this.selectedQuantity[0] = '';
    this.isMobFolderInfoInvoiceNotBlank = false;
    this.isMobFolderInfoInvoiceBlank = false;
    this.newLineIndex = this.items.length;
    this.discount_type = 'dollor';
    this.user_id = localStorage.getItem('id');
    this.inv_number = 0;
    this.checkbox_value = [];
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);
    this.mobile_invoice_item_id = '';
    this.currentUserRole = localStorage.getItem('role_name');

    this.inv_pdf_path = '';

    this.autoload_check = 'yes';

    //get customer for mobile and other role user
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'all',
    }
    this._contact.getAssignContactListByid(customerModal)
      .subscribe(
        res => {
          this.customerList = res;
        },
      );

    this._activatedroute.params.subscribe(params => {
      this.folderid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
      this.folder_id_e = params['id'];
      this.folderid_encrypt = params['id'];
    });

    //code added by deepak on 21/march/2022
    if (this.folder_id_e.includes("~~ei")) {
      this.step1Div = false;
      this.createInvoiceDiv = true;
      this.invoice_label_edit_div = true;
    }

    this.getFolderInfo(this.folderid);

    this.uploadForm = this.formbuilder.group({
      document: [null, null],
      folder_id: [],
      mobile_number: [],
    });

    this.uploadForm.get('folder_id').setValue(this.folderid);

    //// get folder file
    this.getFolderImage(this.folderid, 'image');
    this.getFolderDocument(this.folderid, 'document');

    //this line function added by deepak on 13/april/2022
    this.getConfidentialFiles(this.folderid, 'all');

    this.get_company_by_id();
    this.random = this.getRandomInt(1000);

    $(document).on("click", '.selected-item', function (event) {
      $('#saveUserNameCheckBox').prop('checked', false);
    });

    $(document).on("click", '.multiselect-item-checkbox', function (event) {
      $('#saveUserNameCheckBox').prop('checked', false);
    });

    this.userDropdownSettings = {
      singleSelection: false,
      enableCheckAll: false,
      idField: 'id',
      textField: 'user_fullname',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.submitForm = this.formbuilder.group({
      APIKEY: this.APIKEY,
      user_id: [localStorage.getItem('id')],
      company_id: [localStorage.getItem('company_id')],
      frequency: ['', Validators.required],
      entity_name: ['', Validators.required],
      entity_code: ['', Validators.required],
      ref_number: [''],
      invoice_number: [{ value: '', disabled: true }, Validators.required],
      invoice_date: ['', Validators.required],
      due_date: ['', Validators.required],
      subtotal: ['', Validators.required],
      grandtotal: ['',],
      taxamount: ['', Validators.required],
      total_tax: [],
      status: [],
      dynamicFields: this.formbuilder.array([]),
      mobile_invoice_id: [],
      mobile_header_id: this.folderid,
      item_row: [],
      inv_number: this.inv_number,
      mobile_invoice_item_id: [],
      checkbox_value: [],
      autoload_check: this.autoload_check,
      mobnumber: '',
      customer_id: '',
      my_status: false,
    });

    //initialize invoice item list
    const dynamicFieldForm = this.formbuilder.group({
      id: [0],
      Selected: [false],
      mobile_invoice_id: [0],
      professional_customer_id: [''],
      date_worked: [''],
      speciality: [''],
      work_type: [''],
      hours_worked: [''],
      hourly_rate: [0],
      calculated: [0],
      total: [0],
      item_note: [''],
      tax_exempt: [''],
      cost_rate_hidden: [''],
      my_status: false,
    });
    this.dynamicFields.push(dynamicFieldForm);

    this.getUserListMob('normal');
    this.getSelectedUser();
    this.getFolderInfoInvoice();

    if (localStorage.getItem("importsuccess") !== null || localStorage.getItem("importsuccess") !== undefined) {
      this.importsuccess = localStorage.getItem("importsuccess");
      console.log('import importsuccess ', this.importsuccess);
      if (this.importsuccess == 'true') {
        var importcustid = localStorage.getItem("customer_id");
        console.log('import cust id ', importcustid);
        // added by archana 04/03/2023 import professional
        this.step1Div = false;
        this.createInvoiceDiv = true;
        this.getProfessionalImports(importcustid);
        window.addEventListener('scroll', () => { this.onScroll(importcustid) }, true);
      }
    }
    else {
      console.log('import success not exists');
    }
    //ngOnInit end
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener("scroll", () => { this.onScroll() }, false);
  }

  onScroll(customer_id: any = '') {
    const scrollY = $(window).scrollTop();
    // Determine scroll direction based on the current scroll position
    const scrollDirection = scrollY > this.lastScrollY ? 'down' : 'up';
    this.lastScrollY = scrollY;

    if (scrollDirection === 'down' && this.isLoading === false) {
      this.getProfessionalImports(customer_id);
    }
  }

  addLine(index = 0) {
    var isErrorDynamic = 0;
    this.submitForm.value.dynamicFields.forEach((element, index) => {
      // validation added for inactive professional archana 26/07/2023
      var arrPro: any = [];
      arrPro = this.professionalList.filter(pro => pro.product_id == element.professional_customer_id);
      if (arrPro.length == 0) {
        isErrorDynamic++;
        this.submitForm.value.dynamicFields[index].my_status = true;
      } else {
        this.submitForm.value.dynamicFields[index].my_status = false;
        console.log(arrPro);
      }
      // end 
      var date_worked: any = (element.date_worked);
      var professional_customer_id: any = (element.professional_customer_id);
      var speciality: any = (element.speciality);
      var hourly_rate: any = (element.hourly_rate);
      var hours_worked: any = (element.hours_worked);
      var calculated: any = (element.calculated);
      // added by archana yadav on 22/03/2023
      if (element.work_type == "Item") {

        // added by archana yadav on 22/03/2023
        if (professional_customer_id == '' ||
          professional_customer_id == null ||
          professional_customer_id == undefined ||
          speciality == '' ||
          speciality == undefined ||
          speciality == null ||
          hourly_rate == '' ||
          hourly_rate == undefined ||
          hourly_rate == null ||
          hours_worked == '' ||
          hours_worked == "0:00" ||
          hours_worked == "0:00:00" ||
          hours_worked == undefined ||
          hours_worked == null ||
          calculated == '' ||
          calculated == '0' ||
          calculated == null ||
          calculated == undefined ||
          date_worked == '' ||
          date_worked == null ||
          date_worked == '0000-00-00' ||
          date_worked == undefined) {
          // alert(element.work_type);
          isErrorDynamic++;
          this.submitForm.value.dynamicFields[index].my_status = true;
        }
      } else {
        // alert(element.hourly_rate);
        // added by archana yadav on 22/03/2023
        if (professional_customer_id == '' ||
          professional_customer_id == null ||
          professional_customer_id == undefined ||
          speciality == '' ||
          speciality == undefined ||
          speciality == null ||
          hourly_rate == '' ||
          hourly_rate == undefined ||
          hourly_rate == "0:00" ||
          hourly_rate == "0" ||
          hourly_rate == "0:00:00" ||
          hourly_rate == null ||
          hourly_rate == "0" ||
          hourly_rate == "0.00" ||
          hourly_rate == "0.0" ||
          hours_worked == '' ||
          hours_worked == "0:00" ||
          hours_worked == "0:00:00" ||
          hours_worked == undefined ||
          hours_worked == null ||
          calculated == '' ||
          calculated == '0' ||
          calculated == null ||
          calculated == undefined ||
          date_worked == '' ||
          date_worked == null ||
          date_worked == '0000-00-00' ||
          date_worked == undefined) {
          // alert(element.work_type);
          isErrorDynamic++;
          this.submitForm.value.dynamicFields[index].my_status = true;
        }
      }
    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    console.log(this.submitForm.value.dynamicFields)
    if (isErrorDynamic > 0) {
      alert("Please Fill valid data in all fields ");
      this.isDisabled = false;
      return false;
    }
    else {
      const dynamicFieldForm = this.formbuilder.group({
        id: [0],
        Selected: [false],
        mobile_invoice_id: [0],
        professional_customer_id: [''],
        date_worked: [''],
        speciality: [''],
        work_type: [''],
        hours_worked: [''],
        hourly_rate: [0],
        calculated: [0],
        total: [0],
        item_note: [''],
        tax_exempt: [''],
        cost_rate_hidden: [''],
        my_status: false,
      });
      this.dynamicFields.push(dynamicFieldForm);
    }

  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - (currentScroll / 30));
      }
    })();
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  openModalBtn() {
    this.display = 'block';
  }

  onCloseHandled() {
    this.display = 'none';
  }

  getCustomerEmail() {
    this.emailModalError = false;
    this.loaderMode = true;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: this.customer_id,
    }

    this._contact.getContactEmailsByid(folderModel).subscribe(
      res => {
        if (this.currentUserRole != 'Professional User' && this.model.customer_id != 0) {
          this.openModalBtn();
          if (res.data.assign_fact == '3') {
            this.assign_fact_check_css = 'none';
          }
        }
        this.loaderMode = false;
        this.emailModel = res.data;
      },
    );
  }


  //////get folder details getMobileFolderInfo
  getFolderInfo(folderid) {
    this.loaderMode = true;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      mobile_id: folderid
    }

    this._soaImage.getFolderInfo(folderModel).subscribe(
      res => {
        this.loaderMode = false;
        if (res.data.assign_fact == '1' || res.data.assign_fact == '2') {
          this.nonfactmode = 0;
        }
        if (res.data.p_status == 'Yes' && this.currentUserRole == 'Professional User') {
          this._router.navigate(["/mobile/mobile-list"]);
        }
        else {
          this.privatemode = 0;
        }
        this.customer_taxrate = res.data.tax_rate;
        this.ref_number = res.data.reference_number;

        this.inv_number_new = res.data.invoice_number_item;
        this.work_week_val = res.data.work_week;
        this.inv_pdf_path = res.data.inv_pdf_path;

        // inv status By Archana 28march2022
        this.fact_status = res.data.fact_status;

        // inv status By Archana
        this.customer_id = res.data.customer_id;

        if (res.data.merge_pdf_path != '') {
          this.mergeStatus = true;
          this.mergeActionStatus = true;
        }

        if (res.data.user_per == 'all') {
          this.check_per_mode = true;
        }

        this.model = res.data;
        this.inv_payment_status = res.data.inv_payment_status;

        //for customer dropdown
        $(".select2").val(res.data.customer).trigger('change');

        this.importRecordsTotal = res.importRecordsTotal;
        this.getProfessionalList(this.customer_id);
        this.getProfessionalListInactive(this.customer_id);
      },
    );
  }
  ////end

  //code added by rahat Sheikh 14-09-2023
  sendEmailToCust(addform) {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      email_info: this.emailModel,
      folder_id: this.folderid,
    }
    this._soaImage.sendEmailToCustomer(folderModel).subscribe(
      res => {
        this.onCloseHandled();
        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }

        this.emailModal = false;
        if (this.nonfactmode == 0) {
          //added and updated by archana on 21/07/2023 
          this.updateCheckInvoice(this.folderid);
          // end
        }
      },
    );
  }
  //-------------added by archana on 21/07/2023(rahat-14-09-2023)  for sent to factor factoring ---------- /
  onSubmitFolder(status = 'no') {
    this.btnDisableFact = true;
    this.modelFact['APIKEY'] = this.APIKEY;
    this.modelFact['user_id'] = this.user_id;
    this.modelFact['company_id'] = this.company_id;
    this.modelFact['folder_id'] = this.folderid;
    this.modelFact['invoice_mode'] = this.factInvoiceMode;
    this.modelFact['invoice_id'] = this.fact_invoice_id;
    this.modelFact['date_invoice'] = this.datePipe.transform(this.modelFact['date_invoice'], 'MM/dd/yyyy, hh:mm a');
    this.modelFact['work_week'] = this.datePipe.transform(this.modelFact['work_week'], 'MM/dd/yyyy, hh:mm a');
    this._factInvoice.factInvoiceSave(this.modelFact).subscribe(
      res => {
        //status 'No' means form me kuch change nahi kiya hai
        if (status == 'no') {
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            //this._router.navigateByUrl('/mobile/mobile-list');
            this._router.navigateByUrl('/factoring/factoring-tab1');
          });
        }
      },
    );
  }

  updateCheckInvoice(folderid) {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      mobile_id: folderid,
    }
    this._factInvoice.updateCheckfact(folderModel)
      .subscribe(
        res => {
          if (res.status == true) {
            this.factInvoiceMode = 'edit';
            this.fact_invoice_id = res.data[0].id;
          }
          this.getFolderInfoforfactoring(this.folderid);
        },
      );
  }
  getFolderInfoforfactoring(folderid) {
    this.loaderMode = true;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      mobile_id: folderid,
    }
    this.rfolderid = this.EncrDecr.set(localStorage.getItem('key'), folderid)
    this._factInvoice.getFolderInfo(folderModel)
      .subscribe(
        res => {
          this.modelFact = res.data;
          //invoice number and amount By Archana
          this.modelFact['sub_total'] = res.data.sub_total_inv;
          this.modelFact['tax_amount'] = res.data.inv_tax_amount;
          if (res.data.invoice_number_item) {
            this.modelFact['invoice_number'] = res.data.invoice_number_item;
            this.modelFact['amount'] = res.data.grand_total_inv;
            //INV2000
          }
          else {
            this.modelFact['amount'] = res.data.amt;
            //121
          }
          //invoice number and amount By Archana
          this.pdfSrc = res.data.merge_pdf_path;
          if (res.data.inv_created_date == null) {
            this.modelFact['date_invoice'] = ''; //this.datePipe.transform(dateInvoice, 'MM/dd/yyyy');
          }
          else {
            var di = res.data.inv_created_date;
            di = di.toString().replace(/-/g, "/");
            di = new Date(di);
            this.modelFact['date_invoice'] = this.datePipe.transform(di, 'MM/dd/yyyy');
          }
          if (this.modelFact['work_week'] == null) {
            this.modelFact['work_week'] = '';
          }
          else {
            var ww = this.modelFact['work_week'];
            ww = ww.toString().replace(/-/g, "/");
            ww = new Date(ww);
            this.modelFact['work_week'] = this.datePipe.transform(ww, 'MM/dd/yyyy');
          }
          //invoice date By Archana
          if (this.factInvoiceMode != 'add') {
            this.modelFact['terms'] = res.data.factterms;
          }
          this.loaderMode = false;
          // added by archana on 21/07/2023 sent to factoring
          this.onSubmitFolder('no');
        },
      );
  }
  //************************end*******************

  captureScreen() {
    var data = document.getElementById('canvas');
    html2canvas(data).then(function (canvas) {
      // var generatedImage = canvas.toDataURL("image/png");
      var generatedImage = canvas.toDataURL("image/png").replace(/^data:image\/[^;]/, 'data:application/octet-stream');
      localStorage.setItem('image64data', generatedImage);

      var link = document.createElement("a");
      link.download = "MaSimulation.png";
      link.href = generatedImage;
      document.body.appendChild(link);
      // link.click();
    });

    setTimeout(() => {
      this.canvasmode = false;
    }, 300);
  }

  //////model function
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  openModal3(template: TemplateRef<any>) {
    this.pdfSrc = '';
    this.modalRef = this.modalService.show(template, this.config3);
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config1);
  }

  openModal2(template: TemplateRef<any>) {
    // alert(template);
    this.modalRef = this.modalService.show(template, this.config2);
  }

  setFilePath(filepath) {
    this.filePath = filepath;
  }

  setDocFilePath(filepath) {
    this.pdfSrc = filepath;
  }

  setEdiFileValue(name, id) {
    this.fileModel['filename'] = name;
    this.fileModel['fileid'] = id;
  }

  onSubmitFile() {
    this.fileModel['APIKEY'] = this.APIKEY;
    this.fileModel['user_id'] = this.user_id;
    this.fileModel['folder_id'] = this.folderid;
    this.fileModel['company_id'] = this.company_id;
    this._soaImage.updateFolderFileName(this.fileModel)
      .subscribe(
        res => {
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/mobile/edit-mobile/' + this.folder_id_e);
          });
          this.modalRef.hide();
        },
      );

  }

  ////end
  /// multiple file upload code start
  queue_length: any;
  //added isClickOnHiddenBtn in this function by deepak on 13/April/2022
  //uploadSubmit() {
  uploadSubmit(isClickOnHiddenBtn) {
    this.loaderMode = true;
    this.queue_length = this.uploader.queue.length;
    if (this.uploader.queue.length > 0) {
      for (let i = 0; i < this.uploader.queue.length; i++) {
        let fileItem = this.uploader.queue[i]._file;
        if (fileItem.type == 'application/pdf' || fileItem.type == 'image/png' || fileItem.type == 'image/jpeg' || fileItem.type == 'image/jpg' || fileItem.type == 'image/bmp' || fileItem.type == 'image/gif' || fileItem.type == 'image/tif' || fileItem.type == 'image/tiff' || fileItem.type == 'image/svg' || fileItem.type == 'image/webp' || fileItem.type == 'image/pjp' || fileItem.type == 'image/xbm' || fileItem.type == 'image/jxl' || fileItem.type == 'image/svgz' || fileItem.type == 'image/ico' || fileItem.type == 'image/avif' || fileItem.type == 'image/bmp' || fileItem.type == 'image/jfif' || fileItem.type == 'image/apng') {
          // alert('chala');
          if (i + 1 == this.uploader.queue.length) {
            var successFileCount = 0;
            var $this = this;
            var j = 0;
            testFun(j);

            $this.uploadFileUrl = [];

            function testFun(j) {
              "use strict";
              if (j < $this.uploader.queue.length) {
                let data = new FormData();
                let fileItem = $this.uploader.queue[j]._file;

                data.append('isConfidentialFile', isClickOnHiddenBtn);
                data.append('file', fileItem);
                data.append('fileSeq', 'seq' + j);
                data.append('APIKEY', $this.APIKEY);
                data.append('user_id', $this.user_id);
                data.append('company_id', $this.company_id);
                data.append('folder_id', $this.uploadForm.controls.folder_id.value);

                $this.uploadFile(data).subscribe(res => {
                  successFileCount = successFileCount + res.count;
                  $this.uploadFileUrl.push(res.return_url);

                  if (j + 1 == $this.uploader.queue.length) {
                    $this.loaderMode = false;
                    $this.getFolderImage($this.folderid, 'image');
                    $this.getFolderDocument($this.folderid, 'document');
                    $this.getConfidentialFiles($this.folderid, 'all');
                    //$this.getCompanyFactEmail();
                    $this.sendnotification($this.uploadFileUrl);
                    $this.uploader.clearQueue();
                  } else {
                    j++;
                    testFun(j);
                  }
                });
              }
            }
          }
        }
        else {
          alert('Only Images/Pdfs are allowed');
          this.RemoveElementFromStringArray1(this.uploader.queue[i]);
          return false;
        }
        if (fileItem.size > 9999999999999999) {
          alert("Each File should be less than 10 MB of size.");
          return;
        }
      }
    } else {
      this.loaderMode = false;
      alert("Please select file");
    }
  }

  RemoveElementFromStringArray1(element: any) {
    for (let i = 0; i < this.uploader.queue.length; i++) {
      if (this.uploader.queue[i] == element) {
        this.uploader.queue.splice(i, 1);
      }
    };
    this.loaderMode = false;
  }

  sendnotification(Files) {
    let encrypted = this.EncrDecr.set(localStorage.getItem('key'), this.folderid);
    if (Files.length > 0) {
      const data = {
        APIKEY: this.APIKEY,
        user_id: this.user_id,
        folder_id: this.folderid,
        company_id: this.company_id,
        customer: this.model.customer,
        customer_name: this.model.customer_name,
        customer_id: this.model.customer_id,
        work_week: this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a'),
        uploader: this.queue_length,
        uploadFileUrl: Files,
        encrypted: encrypted
      }

      this._soaImage.sendnotification(data)
        .subscribe(
          res => {
            this.loaderMode = false;
            this.uploadFileUrl = [];
          },
        );
    } else {
      this.loaderMode = false;
      alert("Please select file");
    }
  }

  uploadFile(data: FormData): Observable<any> {
    return this.http.post<any>('https://factor-ccc-staffing.mybizpad.com/rest_api/api/SoaImage/uploadFolderDoc', data);
  }

  // multiple file upload  code end
  // get folder file 100
  getFolderImage(folderid, type) {
    const fileModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      folder_id: this.folderid,
      type: type,
      company_id: this.company_id,
      mobileuserrole: this.currentUserRole,
    }
    this._soaImage.getFolderFileList1(fileModal)
      .subscribe(
        res => {
          this.imagesCount = res.length;
          this.folderImageList = res;
        },
      );
  }

  getFolderDocument(folderid, type) {
    const fileModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      folder_id: this.folderid,
      type: type,
      company_id: this.company_id,
      mobileuserrole: this.currentUserRole,
    }

    this._soaImage.getFolderFileList1(fileModal)
      .subscribe(
        res => {
          this.folderDocList = [];
          this.pdfCount = 0;
          if (res.length > 0) {
            /*added code by deepak on 04/April/2022*/
            if (this.screenWidth <= 949) {
              this.defaultZoom = 1;
            } else if (this.screenWidth <= 950 && this.screenWidth <= 1024) {
              this.defaultZoom = 0.75;
            } else if (this.screenWidth >= 1025 && this.screenWidth <= 1359) {
              this.defaultZoom = 1;
            } else if (this.screenWidth >= 1360 && this.screenWidth <= 1600) {
              this.defaultZoom = 1.25;
            } else {
              this.defaultZoom = 1.50;
            }

            if (type == 'document') {
              this.pdfCount = res.length;
              this.folderDocList = res;
            }
          }
        },
      );
  }
  // end folder file

  //function created by deepak on 13/april/2022
  getConfidentialFiles(folderid, type) {
    const fileModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      folder_id: this.folderid,
      type: type,
      company_id: this.company_id,
      mobileuserrole: this.currentUserRole,
    }
    this._soaImage.getConfidentialFiles(fileModal)
      .subscribe(
        res => {
          if (this.screenWidth <= 949) {
            this.defaultZoom = 1;
          } else if (this.screenWidth <= 950 && this.screenWidth <= 1024) {
            this.defaultZoom = 0.75;
          } else if (this.screenWidth >= 1025 && this.screenWidth <= 1359) {
            this.defaultZoom = 1;
          } else if (this.screenWidth >= 1360 && this.screenWidth <= 1600) {
            this.defaultZoom = 1.25;
          } else {
            this.defaultZoom = 1.50;
          }

          this.confidentialFilesCount = res.length;
          this.folderConfidentialList = res;
        },
      );
  }

  //ajax submit folder information when upload files
  demo: any = [];
  selectedIds: any = [];

  onSubmitMFolderAjax(sat = 0) {
    this.model['APIKEY'] = this.APIKEY;
    this.model['user_id'] = this.user_id;
    this.model['folder_id'] = this.folderid;
    this.model['company_id'] = this.company_id;
    this.model['Additional_access'] = JSON.stringify(this.selectedUsers);
    this.model['user_per'] = this.user_per;

    this.model['customer'] = $(".select2").val();

    if (this.model['reference_number'] == ''
      && this.model['po_number'] == ''
      && this.model['work_week'] == ''
      // && this.model['load_number'] == '' 
      && this.model['mobile_invoice_number'] == ''
    ) {
      this.validFolderError = true;
      return false;
    }
    else {

      this.model['work_week'] = this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a');
      if (this.model['work_week'] != '') {
        this.work_week_val = this.model['work_week'];
      }
      this.validFolderError = false;
      this._soaImage.updateMobileFolder(this.model)
        .subscribe(
          res => {
            this.isMobFolderInfoChange = false;
            if (sat == 1 || sat == 0 || sat == 3)
              this.toastr.success(res.message, 'Success');
          },
        );

      if (this.inv_number_new != '') {
        this.autoload_check = 'no';
      }
      this.autoload_check = 'yes';

    }
  }


  //send edit mobile link to all Professional Users
  send_sms_to_additional_user() {
    const data = {
      APIKEY: this.APIKEY,
      company_id: this.company_id,
      folderid: this.folderid,
      user_id: this.user_id,
      selectedUsers: JSON.stringify(this.selectedUsers),
      encrypted: this.EncrDecr.set(localStorage.getItem('key'), this.folderid),
      Additional_access: JSON.stringify(this.selectedUsers),
      customer_id: this.customer_id
    }

    if (this.selectedUsers.length > 0) {
      this._user.sendSmsToAdditionalUser(data)
        .subscribe(
          res => {
            if (res.status == true) {
              this.toastr.success(res.message, 'Success');
            } else {
              // this.toastr.error(res.message, 'Error');
              alert(res.message);
            }
          },
          err => console.log(err)
        );
    } else {
      this.toastr.error('User not selected', 'Error');
    }

  }

  set_delete_id(cid) {
    this.delete_id = cid;
  }

  deletefolderdoclist(cid) {
    delete this.folderDocList['id'];
  }

  set_delete_merge_id(id) {
    this.merge_delete_id = id;
  }

  delete_mergefile() {
    const data = {
      delete_id: this.delete_id,
      APIKEY: this.APIKEY,
      mobile_id: this.merge_delete_id,
    }

    this._soaImage.deleteMergeFile(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          this.mergeActionStatus = false;
          this.getFolderInfo(this.folderid);
        },
        err => console.log(err)
      );
  }
  /////set
  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    this.isMobFolderInfoChange = true;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k == 32 && k == 45) || (k >= 48 && k <= 57));
  }

  omits_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return (k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  delete_user() {
    const data = {
      delete_id: this.delete_id,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
    }
    this._soaImage.deleteFolderFile(data)
      .subscribe(
        res => {

          this.toastr.success(res.message, 'Success');
          this.getFolderDocument(this.folderid, 'document');
          this.getFolderImage(this.folderid, 'image');
          this.getConfidentialFiles(this.folderid, 'all');
        },
        err => console.log(err)
      );
  }
  /////set

  rotateFolderFile(filePath) {
    this.filePath = filePath;
  }

  rotate_file() {
    const data = {
      file_path: this.filePath,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
    }

    this._soaImage.rotateFolderFile(data)
      .subscribe(
        res => {
          this.random = this.getRandomInt(1000);
          this.toastr.success(res.message, 'Success');
          this.getFolderDocument(this.folderid, 'document');
          this.getFolderImage(this.folderid, 'image');
          this.getConfidentialFiles(this.folderid, 'all');
        },
        err => console.log(err)
      );
  }

  get_company_by_id() {
    const data = {
      company_id: this.company_id,
      APIKEY: this.APIKEY
    }
    this.canvasmode = true;
    this._company.getCompanyById(data)
      .subscribe(
        res => {
          this.factmodel = res.data;
          this.factInstructions = res.data.instructions;
          this.factAssigned_notice = res.data.assigned_notice;
          this.factFinance_company = res.data.finance_company;
          this.factFact_address1 = res.data.fact_address1;
          this.factFact_city_state = res.data.fact_city_state;
          this.factFact_email = res.data.fact_email;

          setTimeout(() => {
            this.captureScreen();
          }, 200);
        },
        err => console.log(err)
      );
  }

  redirectedinto(folderid) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), folderid);
    this._router.navigate(["/mobile/factoring-invoice/" + encrypted]);
  }

  redirected(folderid) {
    if (this.work_week_val == '' && this.inv_number_new == null) {
      alert('Please fill the Work Week and / or create an Invoice before merging files');
    }
    else if (this.work_week_val == '' || this.work_week_val == null) {
      alert('Please fill the Work Week and save data');
    }
    else if (this.inv_number_new == null) {
      alert('Please create an Invoice before merging files');
    }
    else {
      var encrypted = this.EncrDecr.set(localStorage.getItem('key'), folderid);
      this._router.navigate(["/mobile/file-merge/" + encrypted]);
    }
  }
  setpdfPath(filepath) {
    this.filePath = filepath;
  }

  //create imgae to pdf code here
  setFilePDF(filepath, id) {
    this.filePath = filepath;
    const fileModalPDF = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      file_id: id,
      company_id: this.company_id,
      filepath: this.filePath,
    }

    this._soaImage.imageConvertPdf(fileModalPDF)
      .subscribe(
        res => {
          this.pdfSrc = res;
        },
      )
  };

  getUserListMob(mode) {
    const data = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active'
    };

    this._user.getuserListByIdMob(data)
      .subscribe(
        res => {
          if (res.status == true) {
            if (mode == 'custper') {
              this.selectedUsers = res.data;
            }
            this.userList = res.data;
          }

        },
      );
  }

  getSelectedUser() {
    const data = {
      APIKEY: this.APIKEY,
      folder_id: this.folderid,
      company_id: this.company_id,
    };
    this._soaImage.getAdditionalMobileUsers(data).subscribe(
      res => {
        this.selectedUsers = res['data'];

      }
    );
  }

  onCustomerPer(value: boolean) {
    if (value != true) {
      this.selectedUsers = [];
      this.user_per = '';
    }
    else {
      const mode = 'custper';
      this.getUserListMob(mode);
      this.user_per = 'all';
    }
  }
  viewString: any;
  prestring: any;
  onViewSelect(item: any) {
    this.isMobFolderInfoChange = true;
  }


  downloadimage(url) {
    var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (d: any) => {
        saveAs(d, fileName);
      },
      (err: any) => {
        console.log("error", err)
      }
    )
  }

  downloadpdf(url) {
    var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (d: any) => {
        saveAs(d, fileName);
      },
      (err: any) => {
        console.log("error", err)
      }
    )
  }

  createInvoice(folderId, customerId) {
    this.step1Div = false;
    this.createInvoiceDiv = true;

    console.log('folderId ', folderId);
    console.log('customerId ', customerId);
  }


  //this function is for delete import invoice data
  hideInvoice(mobnumber) {
    this.deleteImportProfessionals(mobnumber);
    localStorage.removeItem('MobNumber');
    localStorage.removeItem('customer_id');
    localStorage.removeItem('importsuccess');

    if (this.importsuccess == 'true') {
      for (var i = this.dynamicFields.controls.length - 1; i >= 0; i--) {
        this.dynamicFields.removeAt(i);
      }

      this.submitForm.get('subtotal').setValue(0.00);
      this.submitForm.get('taxamount').setValue(0.00);
      this.submitForm.get('grandtotal').setValue(0.00);
      this.addLine();
    }

    this.step1Div = true;
    this.createInvoiceDiv = false;
  }

  // Delete the import data when click on cancel or back button by deepak 03/april/2023
  deleteImportProfessionals(mobnumber) {
    const data = {
      APIKEY: this.APIKEY,
      company_id: this.company_id,
      customer_id: this.customer_id,
      mobnumber: mobnumber
    };

    this._professional.DeleteProInfoForImport(data)
      .subscribe(
        res => {
          if (res.status == true) {
            return true;
          } else {
            return false;
          }
        },
      );
  }

  addInvoice(status = 'Act', index = 0) {
    this.loaderMode = true;
    this.isDisabled = true;
    var isErrorDynamic = 0;
    this.submitForm.get('autoload_check').setValue(this.autoload_check);
    this.submitForm.get('mobile_invoice_item_id').setValue(this.mobile_invoice_id);
    this.submitForm.get('inv_number').setValue(this.inv_number);
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    this.submitForm.get('mobile_header_id').setValue(this.folderid);
    this.submitForm.get('user_id').setValue(this.user_id);
    this.submitForm.get('status').setValue(status);

    var mob = '';
    var cust = '';
    mob = localStorage.getItem('MobNumber');
    cust = localStorage.getItem('customer_id');
    if (mob != '' && cust != '') {
      this.submitForm.get('mobnumber').setValue(mob);
      this.submitForm.get('customer_id').setValue(cust);
    }

    //For validation
    this.submitForm.value.dynamicFields.forEach((element, index) => {
      // validation added for inactive professional archana 26/07/2023
      var arrPro: any = [];
      arrPro = this.professionalList.filter(pro => pro.product_id == element.professional_customer_id);
      if (arrPro.length == 0) {
        isErrorDynamic++;
      } else {
        console.log(arrPro);
      }
      // end 
      element.date_worked = (element.date_worked) ? this.datePipe.transform(element.date_worked, 'MM/dd/yyyy') : '';
      var date_worked: any = (element.date_worked);
      var professional_customer_id: any = (element.professional_customer_id);
      var speciality: any = (element.speciality);
      var hourly_rate: any = (element.hourly_rate);
      var hours_worked: any = (element.hours_worked);
      var calculated: any = (element.calculated);
      console.log(element);
      // return false;
      if (status == 'yes') {
        if (element.work_type == "Item") {

          // added by archana yadav on 22/03/2023
          if (professional_customer_id == '' ||
            professional_customer_id == null ||
            professional_customer_id == undefined ||
            speciality == '' ||
            speciality == undefined ||
            speciality == null ||
            hourly_rate == '' ||
            hourly_rate == undefined ||
            hourly_rate == null ||
            hours_worked == '' ||
            hours_worked == "0:00" ||
            hours_worked == "0:00:00" ||
            hours_worked == undefined ||
            hours_worked == null ||
            calculated == '' ||
            calculated == '0' ||
            calculated == null ||
            calculated == undefined ||
            date_worked == '' ||
            date_worked == null ||
            date_worked == '0000-00-00' ||
            date_worked == undefined) {
            // alert(element.work_type);
            isErrorDynamic++;
            this.submitForm.value.dynamicFields[index].my_status = true;
          }
        } else {
          // alert(element.hourly_rate);
          // added by archana yadav on 22/03/2023
          if (professional_customer_id == '' ||
            professional_customer_id == null ||
            professional_customer_id == undefined ||
            speciality == '' ||
            speciality == undefined ||
            speciality == null ||
            hourly_rate == '' ||
            hourly_rate == undefined ||
            hourly_rate == "0:00" ||
            hourly_rate == "0" ||
            hourly_rate == "0:00:00" ||
            hourly_rate == null ||
            hourly_rate == '0' ||
            hourly_rate == '0.00' ||
            hourly_rate == '0.0' ||
            hours_worked == '' ||
            hours_worked == "0:00" ||
            hours_worked == "0:00:00" ||
            hours_worked == undefined ||
            hours_worked == null ||
            calculated == '' ||
            calculated == '0' ||
            calculated == null ||
            calculated == undefined ||
            date_worked == '' ||
            date_worked == null ||
            date_worked == '0000-00-00' ||
            date_worked == undefined) {
            // alert(element.work_type);
            isErrorDynamic++;
            this.submitForm.value.dynamicFields[index].my_status = true;
          }
        }

      }

    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    // return false;
    if (isErrorDynamic > 0) {
      this.loaderMode = false;
      alert("Please Fill valid data in all fields.");
      this.isDisabled = false;
      return false;
    }

    if (isErrorDynamic == 0) {
      //For validation
      this._user.addInvoice(this.submitForm.getRawValue()).subscribe(
        (response) => {
          this.loaderMode = false;
          if (response && response['status'] == true) {
            if (status == 'yy') {
              this.getFolderDocument(this.folderid, 'document');
              this.getConfidentialFiles(this.folderid, 'all');
              this.isDisabled = false;
            }
            if (status == 'yes') {
              this.toastr.success(response['message'], 'success!');
              localStorage.removeItem('MobNumber');
              localStorage.removeItem('customer_id');
              this.isDisabled = false;
              window.location.reload();
            }
            if (status == 'y') {
              this.toastr.success(response['message'], 'success!');
              this.isDisabled = false;
              var encrypted = this.EncrDecr.set(localStorage.getItem('key'), this.folderid);
              this._router.navigate(["/mobile/file-merge/" + encrypted]);
            }
            console.log('status status ', status);
            if (status == 'driver') {
              this.getFolderDocument(this.folderid, 'document');
              this.getConfidentialFiles(this.folderid, 'all');
              this.isDisabled = false;
            }
          }
        }, err => {
          console.log(err);
        }
      );
    }
  }

  deleteRow(lessonIndex) {
    this.deletearrayInvoice = []; // the ids wants to deleted
    var selectedValue: any = false; // is selected
    var selectedCount: any = 0; // how many selected
    var deletedindexes: any = []; // indexes that has to be delete
    // added to check if any row is selected to delete by archana
    var sss = new Array();
    var i = 0;
    this.submitForm.value.dynamicFields.forEach((element, index) => {
      if (element.Selected == true) {
        sss.push(i);
        selectedValue = true;
        selectedCount++;
        if (element.mobile_invoice_id != '') {
          // added by archana for invoice id arrray delete 
          this.deletearrayInvoice.push(element.mobile_invoice_id)
          // end
        }
        deletedindexes.push(index);
      }
      i++;
    })
    // when row is selected and not equals to all rows selected
    if (selectedValue == true && this.submitForm.value.dynamicFields.length != selectedCount) {
      var delBtn = confirm(" Do you want to delete ?");
      if (delBtn == true) {
        // if create invoice
        if (this.invoice_label_create_div == true) {
          for (var i = sss.length - 1; i >= 0; i--) {
            this.dynamicFields.removeAt(sss[i]);
          }
          this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
        } // end // if create invoice 
        // if edit invoice
        if (this.invoice_label_edit_div == true) {
          var isErrorDynamic = 0;
          this.submitForm.value.dynamicFields.forEach((element, index) => {
            // validation added for inactive professional archana 26/07/2023
            if (element.Selected == false) {
              var arrPro: any = [];
              arrPro = this.professionalList.filter(pro => pro.product_id == element.professional_customer_id);
              if (arrPro.length == 0) {
                isErrorDynamic++;
                this.submitForm.value.dynamicFields[index].my_status = true;
              } else {
                this.submitForm.value.dynamicFields[index].my_status = false;
                console.log(arrPro);
              }
              // end 
              element.date_worked = (element.date_worked) ? this.datePipe.transform(element.date_worked, 'MM/dd/yyyy') : '';
              console.log(element.professional_customer_id)
              var date_worked: any = (element.date_worked);
              var professional_customer_id: any = (element.professional_customer_id);
              var speciality: any = (element.speciality);
              var hourly_rate: any = (element.hourly_rate);
              var hours_worked: any = (element.hours_worked);
              var calculated: any = (element.calculated);
              // added by archana yadav on 22/03/2023
              if (element.work_type == "Item") {

                // added by archana yadav on 22/03/2023
                if (professional_customer_id == '' ||
                  professional_customer_id == null ||
                  professional_customer_id == undefined ||
                  speciality == '' ||
                  speciality == undefined ||
                  speciality == null ||
                  hourly_rate == '' ||
                  hourly_rate == undefined ||
                  hourly_rate == null ||
                  hours_worked == '' ||
                  hours_worked == "0:00" ||
                  hours_worked == "0:00:00" ||
                  hours_worked == undefined ||
                  hours_worked == null ||
                  calculated == '' ||
                  calculated == '0' ||
                  calculated == null ||
                  calculated == undefined ||
                  date_worked == '' ||
                  date_worked == null ||
                  date_worked == '0000-00-00' ||
                  date_worked == undefined) {
                  // alert(element.work_type);
                  isErrorDynamic++;
                  this.submitForm.value.dynamicFields[index].my_status = true;
                }
              } else {
                // alert(element.hourly_rate);
                // added by archana yadav on 22/03/2023
                if (professional_customer_id == '' ||
                  professional_customer_id == null ||
                  professional_customer_id == undefined ||
                  speciality == '' ||
                  speciality == undefined ||
                  speciality == null ||
                  hourly_rate == '' ||
                  hourly_rate == undefined ||
                  hourly_rate == "0:00" ||
                  hourly_rate == "0" ||
                  hourly_rate == "0:00:00" ||
                  hourly_rate == null ||
                  hourly_rate == "0" ||
                  hourly_rate == "0.00" ||
                  hourly_rate == "0.0" ||
                  hours_worked == '' ||
                  hours_worked == "0:00" ||
                  hours_worked == "0:00:00" ||
                  hours_worked == undefined ||
                  hours_worked == null ||
                  calculated == '' ||
                  calculated == '0' ||
                  calculated == null ||
                  calculated == undefined ||
                  date_worked == '' ||
                  date_worked == null ||
                  date_worked == '0000-00-00' ||
                  date_worked == undefined) {
                  // alert(element.work_type);
                  isErrorDynamic++;
                  this.submitForm.value.dynamicFields[index].my_status = true;
                }
              }
            }
          });
          this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);

          if (isErrorDynamic > 0) {
            alert('Please fill the required fields');
          }
          if (isErrorDynamic == 0) {
            // alert('valid data');
            for (var i = sss.length - 1; i >= 0; i--) {
              this.dynamicFields.removeAt(sss[i]);
            }
            this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
            console.log(this.deletearrayInvoice);
            // added to calculate the totals and grand total for invoice
            this.discount_individual('ff');
            // added and modified  by archana on 26/07/2023 for delete data id array 
            if (this.deletearrayInvoice.length > 0) {
              const invoicedelete = {
                APIKEY: this.APIKEY,
                user_id: this.user_id,
                company_id: this.company_id,
                folderid: this.folderid,
                status: 'active',
                mobile_invoice_id: this.deletearrayInvoice,
              }
              this._soaImage.deleteInvoiceItem(invoicedelete).subscribe(
                (response) => {
                  // return;
                  if (response && response['status'] == true && response['data'] != '') {
                    this.addInvoice('yy');
                  }
                });
            }
          }
        } // end // if edit invoice 
      }
    } //end // when row is selected and not equals to all rows selected
    else if (selectedValue == false) {
      alert('Please select any row to delete');
    }
    else {
      alert('Please add minimum one row');
    }

  }



  onlynumberprice(evt, fieldname) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode != 46 && charCode != 45 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  onlyNumbersqty(evt, filed) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode != 45 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  getProfessionalList(cuss_id: any) {
    //this.loaderMode = true;
    const professionaldata = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      customer_id: cuss_id,
    }

    this._professional.getCustomerProfessionalListEditMobile(professionaldata)
      .subscribe(
        res => {
          this.professionalList = res.data;
        }
      );
  }

  getProfessionalListInactive(cuss_id: any) {
    const professionaldata = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      customer_id: cuss_id,
      mobnumber: localStorage.getItem('MobNumber')
    }
    this._professional.getCustomerProfessionalListEditMobileInactive(professionaldata)
      .subscribe(
        res => {
          this.professionalInactiveList = res.inactivePro;
        },
      );
  }

  professionnalDataSet(event, indexx) {
    if (event == '') {
      return false;
    }
    const professionaldata1 = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      product_id: event.target.value,
    }

    this._professional.getCustomerProfessionalPerData(professionaldata1)
      .subscribe(
        res => {
          var i = 0;
          this.submitForm.value.dynamicFields.forEach(element => {
            if (i == indexx) {
              element.speciality = res.data.speciality;
              element.work_type = res.data.work_type;
              element.hourly_rate = res.data.sale_rate;
              element.tax_exempt = res.data.tax_exempt;
              element.tax_exempt = res.data.tax_exempt;
              element.cost_rate_hidden = res.data.cost_rate;
              element.hours_worked = '';
              element.calculated = 0;
              element.total = 0;
              // added by archana 26/07/2023 
              element.my_status = false;
              // end
            }
            i++;
          });
          this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
          document.getElementById("hours_worked" + indexx).focus();
        },
      );
  }

  calualtedHourtoDecimal(value12, lineid) {
    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {
      if (i == lineid) {
        var value = element.hours_worked;
        var hours_multiplier = 1;
        var minute: any = '';
        var second: any = '';
        var str_new_second: any = '';
        if (value.indexOf('-') != -1) {
          hours_multiplier = (-1) * hours_multiplier;
        }
        if (value.indexOf(':') != -1) {
          var hours1 = 0;
          if (value.split(':')[0] != '')
            hours1 = parseInt(value.split(':')[0], 10);
          var minute_m = parseInt(value.split(':')[1], 10);
          var second_m = parseInt(value.split(':')[2], 10);
          var extra = parseInt(value.split(':')[3], 10);
          if (minute_m) {
            minute_m = minute_m;
            var str_new = value.split(':')[1].length;
          } else {
            minute_m = 0;
            str_new = 1;
          }
          if (second_m) {
            second_m = second_m;
            str_new_second = value.split(':')[2].length;
          } else {
            second_m = 0;
            str_new_second = 1;
          } if (extra) {
            element.hours_worked = hours1 + ':' + minute_m + ':' + second_m;
          }

          if (str_new > 1) {

            if (minute_m * 1 > 59) {

              alert('Hours worked minutes can not be greater than 59 mins.');
              var minute_m = 0;
              var hours1 = 0;
              var hours_multiplier = 0;
              var calculated: any = 0;
              element.hours_worked = "0:00";
              $("#hours_worked" + lineid).val("0:00");

              document.getElementById("hours_worked" + lineid).focus();

            } minute = minute_m;

          }
          else {

            minute = '0' + minute_m;
            second = second_m;
            element.hours_worked = hours1 + ':' + minute + ':' + second;
          }
          var hours = (hours1);
          if (str_new_second > 1) {

            if (second_m * 1 > 59) {
              alert('Hours worked second  can not be greater than 59 seconds.');
              var minute_m = 0;
              var hours1 = 0;
              var hours_multiplier = 0;
              var calculated: any = 0;
              element.hours_worked = "0:00:00";
              $("#hours_worked" + lineid).val("0:00:00");

              document.getElementById("hours_worked" + lineid).focus();

            }
            second = second_m;
          }
          else {

            if (second_m != 0) {
              second = '0' + second_m;
              var second_fin = ':' + second;
            } else {
              var second_fin = '';
            }

            element.hours_worked = hours1 + ':' + minute + second_fin;
          }

          if (isNaN(minute)) {
            var minu = '00';
          } if (isNaN(second)) {
            var seco = '00';
          }


          var min1 = (minute / 60);
          var min: any = ((min1).toFixed(2));

          var sec1 = (second / 3600);
          var sec: any = ((sec1).toFixed(2));
          if ((hours * 1) > 0) {
            calculated = (hours * 1 + min * 1 + sec * 1).toFixed(2);
          }
          else {

            calculated = -((hours * 1 - min * 1 - sec * 1).toFixed(2));
          }
          var fin: any = (hours_multiplier * calculated).toFixed(2);
          var todigit: any = 0;
          if (fin % 1 == 0) {
            todigit = parseFloat(fin);
            fin = todigit.toFixed(2);
          }

          element.calculated = fin;
          $("#calculated" + lineid).val((fin));
          if (value.split(':')[0] == '' && value.split(':')[1] != '') {
            $("#hours_worked" + lineid).val('00:' + value.split(':')[1]);
            element.hours_worked = '0:' + value.split(':')[1];
          }

        }
        else {
          if ($("#hours_worked" + lineid).val() == '') {
            element.calculated = 0;
            $("#calculated" + lineid).val(0);
            $("#hours_worked" + lineid).val(0);
            element.hours_worked = '0:00:00';
          }
          else if ($("#hours_worked" + lineid).val() == '-') {
            element.calculated = 0;
            $("#calculated" + lineid).val(0);
            $("#hours_worked" + lineid).val('0:00:00');
            element.hours_worked = '0:00:00';

          }
          else {
            var val = (value * 1);
            element.calculated = val;
            $("#calculated" + lineid).val((val));
            $("#hours_worked" + lineid).val(val + ':00');
            element.hours_worked = val + ':00';
          }
        }
        if (minute * 1 > 59) {
          element.calculated = 0;
          $("#calculated" + lineid).val(0);

          element.hours_worked = "0:00";
        }
        if (second * 1 > 59) {
          element.calculated = 0;
          $("#calculated" + lineid).val(0);
          $("#hours_worked" + lineid).val("0:00:00");
          element.hours_worked = "0:00:00";
        }

      }
      i++;


    });

    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    this.discount_individual(lineid);
  }

  calualtedDecimaltoHour(value12, lineid) {
    var i = 0;
    this.submitForm.value.dynamicFields.forEach(element => {

      if (i == lineid) {
        var value: any = element.calculated;

        if (value == '') {
          value = '0.00';
        }
        var hours_multiplier = 1;
        var minute: any = '';
        var second: any = '';
        var str_new_second: any = '';

        var hours1 = 0;
        if (value.split('.')[0] != '')
          hours1 = parseInt(value.split('.')[0], 10);

        //this below line commented by deepak on 24/march/2023 because of wrong calculation if value like 03,04,06 etc
        //var minute_m = parseInt(value.split('.')[1], 10); 
        //add this line
        var minute_m = value.split('.')[1];

        var hours = (hours1);
        var totalmin: any = '';

        if (isNaN(minute_m)) {
          totalmin = '00';

        } else {
          var minn: any = '0.' + minute_m;
          var min1: any = ((minn * 1) * 60);
          min1 = min1 + '';
          totalmin = parseInt(min1.split('.')[0], 10);
          //var totalsecond=sec

          second = parseInt(min1.split('.')[1], 10);
        }

        if (isNaN(second)) {
          totalsecond = '00';

        } else {

          var secc: any = '0.' + second;
          var sec1 = ((secc * 1) * 60);
          //var totalsecond=sec
          var totalsecond: any = ((sec1).toFixed(2));
          totalsecond = totalsecond + '';
          totalsecond = parseInt(totalsecond.split('.')[0], 10);
        }

        if (totalsecond == 0) {
          totalsecond = '00';
        }
        if (totalmin == 0) {
          totalmin = '00';
        }

        var final_hour: any = hours + ':' + totalmin + ':' + totalsecond;
        element.hours_worked = final_hour;


      }
      i++;
    });

    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    this.discount_individual(lineid);
  }


  discount_individual(str) {
    var qty: any = 0.0;
    var price: number = 0.0;
    var total: any = 0.0;
    var items: any = 0.0;
    var subtotal: any = 0.0;
    var sub_tax: any = 0;
    var total_taxamount: any = 0;
    var subtotal: any = 0;
    var i = 0;
    var todigit: any = '';
    this.submitForm.value.dynamicFields.forEach(element => {
      qty = element.calculated;
      price = element.hourly_rate;

      var qt1: any = element.hours_worked;

      if (qt1.charAt(1) == 'a' || qt1.charAt(1) == '-' || qt1.charAt(2) == '-' || qt1.charAt(3) == '-' || qt1.charAt(4) == '-' || qt1.charAt(5) == '-' || qt1.charAt(6) == '-') {

        $("#hours_worked" + str).val(0)
        $("#calculated" + str).val(0)
        element.calculated = 0;
        element.hours_worked = "0:00:00";
        qty = 0;
        //return false;
      }

      total = ((qty * price)).toFixed(2);
      if (total % 1 == 0) {
        todigit = parseFloat(total);
        total = todigit.toFixed(2);
      }
      var checkk = isNaN(total);
      if (checkk == true) {
        total = 0;
      }
      element.total = total;
      subtotal = (subtotal * 1 + total * 1).toFixed(2);
      if (element.tax_exempt != 1 || element.tax_exempt == null) {
        sub_tax = total * this.customer_taxrate / 100;
        total_taxamount = (total_taxamount * 1 + sub_tax * 1).toFixed(2);
      } else {
        sub_tax = 0;
        total_taxamount = (total_taxamount * 1 + sub_tax * 1).toFixed(2);
      }
      i++;
    });

    if (subtotal % 1 == 0) {
      todigit = parseFloat(subtotal);
      subtotal = todigit.toFixed(2);
    }
    var checkka = isNaN(total_taxamount);
    if (checkka == true) {
      total_taxamount = 0.00;
    }
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    this.submitForm.get('subtotal').setValue(subtotal);
    if (total_taxamount % 1 == 0) {
      todigit = parseFloat(total_taxamount);
      total_taxamount = todigit.toFixed(2);
    }
    var grand_total: any = (subtotal * 1 + total_taxamount * 1).toFixed(2);
    var checkkab = isNaN(grand_total);
    if (checkkab == true) {
      grand_total = 0.00;
    }
    if (grand_total % 1 == 0) {
      todigit = parseFloat(grand_total);
      grand_total = todigit.toFixed(2);
    }
    this.submitForm.get('taxamount').setValue(total_taxamount);
    this.submitForm.get('grandtotal').setValue(grand_total);

  }


  onlynumberic(evt) {
    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 58 || ASCIICode == 45))
      return true;
    return false;
  }

  onlynumbericnegative(event) {
    var charCode = (typeof event.which == "number") ? event.which : event.keyCode;
    var typedChar = String.fromCharCode(charCode);
    if (typedChar == "-" && event.target.value == "") {
      return;
    }
    if ((event.which != 46 || event.target.value.indexOf('.') != -1) &&
      ((event.which < 48 || event.which > 57) && (event.which != 45 || event.target.value.indexOf('-') != -1) &&
        (event.which != 0 && event.which != 8))) {
      event.preventDefault();
    }
    var text = event.target.value;
    if ((text.indexOf('.') != -1) &&
      (text.substring(text.indexOf('.')).length > 2) &&
      (event.which != 0 && event.which != 8) &&
      ($(this)[0].selectionStart >= text.length - 2)) {
      event.preventDefault();
    }
  }

  formreset11() {
    this.uploader.queue = [];
  }

  redirectOnImport(event, MobNumber) {
    localStorage.removeItem('importsuccess');
    localStorage.setItem('MobNumber', MobNumber);
    localStorage.setItem('customer_id', this.customer_id);
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), event);
    this._router.navigate(["/mobile/importmodel/" + encrypted]);
  }

  // added by archana 04/03/2023
  // for import data of professional
  // getting data for intermedeate table
  getProfessionalImports(cust_id) {
    // console.log('getProfessionalImports cust_id ', cust_id);
    console.log('getProfessionalImports isLoading ', this.isLoading);
    if (this.isLoading) {
      return;
    }

    this.showLoaderMsg = true;
    //this.isDisabled = true;
    this.isLoading = true;

    //this.dynamicFields.removeAt(0);

    const professionaldataImp = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      customer_id: cust_id,
      mobnumber: localStorage.getItem('MobNumber'),
      draw: this.drawLoadNo,
      start: this.start
    }
    this._professional.getCustomerProfessionalListImportEditMobile(professionaldataImp)
      .subscribe(
        res => {
          this.importRecordsFiltered = this.importRecordsFiltered + res.data.length;

          if (res.data.length == 0) {
            this.showLoaderMsg = false;
            this.invoice_import = [];
          } else {
            this.invoice_import = this.invoice_import.concat(res.data);
            const dynamicFields = this.submitForm.get('dynamicFields') as FormArray;

            // Remove all existing controls in the dynamicFields FormArray
            while (dynamicFields.length !== 0) {
              dynamicFields.removeAt(0);
            }

            for (let item of this.invoice_import) {
              var calculatedTry = this.calculatedforsingle(item['hours_worked']);

              const dynamicFieldForm = this.formbuilder.group({
                id: [0],
                Selected: [false],
                mobile_invoice_id: [0],
                professional_customer_id: [item['product_line_id_old']],
                date_worked: (item['Date_w_e']) ? this.datePipe.transform(item['Date_w_e'], 'MM/dd/yyyy') : '',
                speciality: item['speciality'],
                work_type: item['work_type'],
                hours_worked: this.hours_worked_s,
                hourly_rate: item['sale_rate'],
                calculated: [this.calculated_s],
                total: [],
                item_note: item['item_note'],
                tax_exempt: [''],
                cost_rate_hidden: item['cost_rate'],
                my_status: false,
              });
              this.dynamicFields.push(dynamicFieldForm);
            }

            this.discount_individual('ff');

            // localStorage.removeItem('MobNumber');
            localStorage.removeItem('importsuccess');
            // localStorage.removeItem('customer_id');

            this.start = res.start;
            this.drawLoadNo++;
            this.isLoading = false;
          }

          this.loaderMode = false;
        },
      );
  }
  // end

  //this function will run when we will do import invoice 
  calculatedforsingle(value) {

    if (value.includes(':')) {
      //Convert Hour to Decimal
      var hours_multiplier = 1;
      var hour = 0;
      var minuteHD = 0;
      var secondHD = 0;
      var minute: any = '';
      var second: any = '';
      var str_new_minute: any = '';
      var str_new_second: any = '';
      var calculated: any = 0;

      if (value.indexOf('-') != -1) {
        hours_multiplier = (-1) * hours_multiplier;
      }

      if (value.split(':')[0] != '') {
        hour = parseInt(value.split(':')[0], 10);
        minuteHD = parseInt(value.split(':')[1], 10);
        secondHD = parseInt(value.split(':')[2], 10);

        if (minuteHD) {
          //minuteHD = minuteHD;
          str_new_minute = value.split(':')[1].length;
        } else {
          minuteHD = 0;
          str_new_minute = 1;
        }

        if (secondHD) {
          //secondHD = secondHD;
          str_new_second = value.split(':')[2].length;
        } else {
          secondHD = 0;
          str_new_second = 1;
        }

        if (str_new_minute > 1) {
          if (minuteHD * 1 > 59) {
            //alert('Hours worked minutes can not be greater than 59 mins.');
            minuteHD = 0;
            hour = 0;
            hours_multiplier = 0;
            calculated = 0;
          }
          minute = minuteHD;
        }
        else {
          minute = '0' + minuteHD;
          second = secondHD;
        }

        //var hours = (hour);
        if (str_new_second > 1) {
          if (secondHD * 1 > 59) {
            //alert('Hours worked second  can not be greater than 59 seconds.');
            minuteHD = 0;
            hour = 0;
            hours_multiplier = 0;
            calculated = 0;
          }
          second = secondHD;
        }
        else {
          second = '0' + secondHD;
        }

        var min1 = (minute / 60);
        var min: any = ((min1).toFixed(2));

        var sec1 = (second / 3600);
        var sec: any = ((sec1).toFixed(2));

        if ((hour * 1) > 0) {
          calculated = (hour * 1 + min * 1 + sec * 1).toFixed(2);
        }
        else {
          calculated = -((hour * 1 - min * 1 - sec * 1).toFixed(2));
        }

        var fin: any = (hours_multiplier * calculated).toFixed(2);
        var todigit: any = 0;
        if (fin % 1 == 0) {
          todigit = parseFloat(fin);
          fin = todigit.toFixed(2);
        }

        this.calculated_s = fin;
        this.hours_worked_s = value;
        return true;
      } else {
        this.hours_worked_s = '0:00';
        this.calculated_s = 0;
        return false;
      }
    }
    else {
      //Convert Decimal to Hour
      if (value == '' || value == null) {
        value = '0.00';
      }

      var hour = 0;
      var second: any = '';
      var minute: any = '';
      var totalmin: any = 0;
      var totalsecond: any = 0;

      if (value.split('.')[0] != '') {
        hour = parseInt(value.split('.')[0], 10);
        //this below line commented by deepak on 24/march/2023 because of wrong calculation if value like 03,04,06 etc
        //var minute = parseInt(value.split('.')[1], 10); 
        //add this line
        minute = value.split('.')[1];
        //var hours = (hour);

        if (isNaN(minute)) {
          totalmin = '00';
        } else {
          var minn: any = '0.' + minute;
          var minDH: any = ((minn * 1) * 60);
          minDH = minDH + '';
          totalmin = parseInt(minDH.split('.')[0], 10);
          second = parseInt(minDH.split('.')[1], 10);
        }

        if (isNaN(second)) {
          totalsecond = '00';
        } else {
          var secc: any = '0.' + second;
          var sec1 = ((secc * 1) * 60);
          var totalsecond: any = ((sec1).toFixed(2));
          totalsecond = totalsecond + '';
          totalsecond = parseInt(totalsecond.split('.')[0], 10);
        }

        if (totalsecond == 0) {
          totalsecond = '00';
        }
        if (totalmin == 0) {
          totalmin = '00';
        }

        var final_hour: any = hour + ':' + totalmin + ':' + totalsecond;
        this.hours_worked_s = final_hour;
        this.calculated_s = value;
        return true;
      } else {
        this.hours_worked_s = '0:00';
        this.calculated_s = 0;
        return false;
      }
    }
  }

  getFolderInfoInvoice() {
    //change invoice button name
    const invoicemodel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      folderid: this.folderid,
      status: 'active',
    }

    this._soaImage.getFolderInfoInvoice(invoicemodel).subscribe(
      (response) => {
        if (response && response['status'] == true && response['data'] != '') {
          this.createdivbutton = false;
          //30march Archana
          if (this.inv_payment_status == 'paid') {
            this.edit_divbutton = false;
            this.isMobFolderInfoInvoiceNotBlank = false;
            this.isInvoicePaymentStatusPaid = true;
          }
          else {
            this.edit_divbutton = true;
          }
          //30march Archana
          this.showInvoicenumDiv = true;
          this.invoice_label_create_div = false;
          this.invoice_label_edit_div = true;

          this.newLineIndex = this.items.length
          this.invoice_item_row = response['data'];
          this.dynamicFields.removeAt(0);
          for (let item of this.invoice_item_row) {
            const dynamicFieldForm = this.formbuilder.group({
              id: [0],
              Selected: [false],
              mobile_invoice_id: [item['mobile_invoice_item_id']],
              professional_customer_id: item['product_line_id'],
              date_worked: (item['date_worked']) ? this.datePipe.transform(item['date_worked'], 'MM/dd/yyyy') : '',
              speciality: item['speciality'],
              work_type: item['work_type'],
              hours_worked: item['hours_worked'],
              hourly_rate: item['hourly_rate'],
              calculated: item['calculated'],
              total: item['total'],
              item_note: item['item_note'],
              tax_exempt: item['item_tax_exempt'],
              cost_rate_hidden: item['cost_rate_hidden'],
              my_status: false
            });
            this.dynamicFields.push(dynamicFieldForm);
          }
          this.discount_individual('ff');
        } else {
          if (this.inv_number_new) {
            this.edit_divbutton = true;
            this.createdivbutton = false;
            this.showInvoicenumDiv = true;
            this.invoice_label_create_div = false;
            this.invoice_label_edit_div = true;
          } else {
            this.createdivbutton = true;
            this.edit_divbutton = false;
            this.showInvoicenumDiv = false;
            this.invoice_label_create_div = true;
            this.invoice_label_edit_div = false;
          }
        }
      }, err => {
        console.log(err);
      }
    );

    //gettting invoice number
    this._soaImage.getInvoiceNumber(invoicemodel).subscribe(
      (response) => {
        if (response && response['status'] == true) {
          this.inv_number = response['invoice_number_item'];
        }
      }, err => {
        console.log(err);
      }
    );
  }
}